import { ApiWrapper } from '../../types';
import { JBaseApi } from '../base';
import { OF } from '../../util/network';

export class JShareApi extends JBaseApi {
    public contentObjectLinks(uri: string): Promise<ApiWrapper<number>> {
        return this.network.post({
            o: 'shared',
            f: 'contentObjectLinks',
            format: 'raw-little',
            uri,
        } as OF);
    }

    public contentSetObjectAccessRule(
        uri: string,
        rule: 'link' | 'invitation',
        hash: string,
    ): Promise<ApiWrapper<boolean>> {
        return this.network.postCSRF({
            o: 'shared',
            f: 'contentSetObjectAccessRule',
            format: 'raw-little',
            uri,
            rule,
            hash,
        } as OF);
    }
}
